import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from './../../../../../../../views/auth/auth.service';
import { environment } from './../../../../../../../../environments/environment';
import { GaleriaVideoService } from './../../../../../services/galeria-video.service';

@Component({
	selector: 'kt-stream-video',
	templateUrl: './stream-video.component.html',
	styleUrls: ['./stream-video.component.scss']
})
export class StreamVideoComponent implements OnInit, OnDestroy {
	private token: string;
	public link1;
	public link2;
	longtabs = [
		{ titulo: "Canal 1" },
		{ titulo: "Canal 2" },
	];


	public loadingVisible: boolean
	public verStream1: boolean = false;
	public verStream2: boolean = false;

	constructor(public dialogRef: MatDialogRef<StreamVideoComponent>,
		private authService: AuthService,
		private galeriVideoService: GaleriaVideoService,
		@Inject(MAT_DIALOG_DATA) private data: any) { }

	ngOnInit() {
		this.token = this.authService.getUser().tokenHW;
		this.obtenerVideo({itemIndex: 0});
	}

	obtenerVideo(tab) {
		this.loadingVisible = true;
		//const chs = 1;
		const stream = 0;
		const wnum = 1;
		const panel = 0;
		switch (tab.itemIndex) {
			case 0:
				this.verStream1 = true;
				this.verStream2 = false;
				this.link1 = `${environment.HOWEN_API}/vss/apiPage/RealVideo.html?token=${this.token}&deviceId=${this.data}&chs=1&stream=${stream}&wnum=${wnum}&panel=${panel}`
				break;
			case 1:
				this.verStream1 = false;
				this.verStream2 = true;
				this.link2 = `${environment.HOWEN_API}/vss/apiPage/RealVideo.html?token=${this.token}&deviceId=${this.data}&chs=2&stream=${stream}&wnum=${wnum}&panel=${panel}`

		}

		setTimeout(() => {
			this.loadingVisible = false;

		}, 4000);

	}

	ngOnDestroy() {
		this.verStream1 = false;
		this.verStream2 = false;
	}



	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
